import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ColorPickerComponent } from './colorpicker.component';
/**
 * NgModule definition for the ColorPicker component.
 */
export class ColorPickerModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    imports: [CommonModule],
    declarations: [
        ColorPickerComponent
    ],
    exports: [
        ColorPickerComponent
    ]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function ColorPickerModule_tsickle_Closure_declarations() {
/** @type {?} */
ColorPickerModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ColorPickerModule.ctorParameters;
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
